export default __webpack_public_path__ + "static/1_15-f37525204121232cbf1c9ae3dac71260.png";